__turbopack_context__.v({
  "actions": "IncompleteProfile-module-scss-module__Ymi6EG__actions",
  "checklist": "IncompleteProfile-module-scss-module__Ymi6EG__checklist",
  "content": "IncompleteProfile-module-scss-module__Ymi6EG__content",
  "description": "IncompleteProfile-module-scss-module__Ymi6EG__description",
  "eyebrow": "IncompleteProfile-module-scss-module__Ymi6EG__eyebrow",
  "ghost": "IncompleteProfile-module-scss-module__Ymi6EG__ghost",
  "ghostBar": "IncompleteProfile-module-scss-module__Ymi6EG__ghostBar",
  "ghostIcon": "IncompleteProfile-module-scss-module__Ymi6EG__ghostIcon",
  "ghostLabel": "IncompleteProfile-module-scss-module__Ymi6EG__ghostLabel",
  "ghostText": "IncompleteProfile-module-scss-module__Ymi6EG__ghostText",
  "percentage": "IncompleteProfile-module-scss-module__Ymi6EG__percentage",
  "preview": "IncompleteProfile-module-scss-module__Ymi6EG__preview",
  "ring": "IncompleteProfile-module-scss-module__Ymi6EG__ring",
  "root": "IncompleteProfile-module-scss-module__Ymi6EG__root",
  "title": "IncompleteProfile-module-scss-module__Ymi6EG__title",
});
